import { render, staticRenderFns } from "./EinvoicePolicy.vue?vue&type=template&id=81f187d2&lang=pug&"
import script from "./EinvoicePolicy.vue?vue&type=script&lang=js&"
export * from "./EinvoicePolicy.vue?vue&type=script&lang=js&"
import style0 from "./EinvoicePolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports